import { render } from "./ModifyArticle.vue?vue&type=template&id=466acdcc&scoped=true"
import script from "./ModifyArticle.vue?vue&type=script&lang=js"
export * from "./ModifyArticle.vue?vue&type=script&lang=js"

import "./ModifyArticle.vue?vue&type=style&index=0&id=466acdcc&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-466acdcc"]])

export default __exports__